<template>
  <div>
    <jd-dialog
      :visible.sync="dialogVisible"
      append-to-body
      width="1200px"
      :sureLoading="sureLoading"
      @close="handleClose"
      @comfirm="handleConfirm"
    >
      <template #title>
        <div>
          <span class="dialog-title">选择人群方案</span>
          <span class="dialog-sub">选择本次需要生成的人群方案</span>
        </div>
      </template>
      <div class="select-group-content">
        <div class="select-group-header">
          <span class="select-group-count">已勾选{{ selectedCount }}条</span>
        </div>
        <div class="select-group-table-wrapper">
          <jd-table
            :showPage="false"
            :selection="true"
            rowKey="crowdNo"
            :tableInfo="tableInfo"
            :tableData="tableData"
            :maxHeight="maxHeight"
            :loading="loading"
            @selection-change="handleSelectionChange"
          >
            <template #tagCombination="{ row }">
              <div class="text-wrap">{{ row.tagCombination }}</div>
            </template>
          </jd-table>
        </div>
      </div>
    </jd-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCrowdJson, confirmCrowd } from "@/api/ai/newAi";
export default {
  name: "SelectGroup",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      maxHeight: "520",
      loading: false,
      tableData: [],
      selectedRows: [],
      tableInfo: [
        { prop: "crowdNo", label: "人群编号", width: "100" },
        { prop: "crowdName", label: "人群名称", minWidth: "160" },
        {
          prop: "tagCombination",
          label: "标签组合",
          minWidth: "240",
          slot: "tagCombination",
        },
        { prop: "crowdFeature", label: "人群特征", minWidth: "200" },
        { prop: "coreGoal", label: "核心目标", width: "120" },
      ],
      sureLoading: false,
    };
  },
  computed: {
    ...mapGetters(["loginUserInfo"]),
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    selectedCount() {
      return this.selectedRows.length;
    },
  },
  created() {
    this.getCrowdJsonFn();
  },
  methods: {
    getCrowdJsonFn() {
      this.loading = true;
      getCrowdJson({
        platform: "JD",
        userId: this.loginUserInfo.platformAccountInfo.platformCompanyUserId,
        messageId: this.item.id,
      })
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.tableData = res.data || [];
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleConfirm() {
      if (!this.selectedRows.length) {
        this.$message.warning("人群方案不可为空，请选择人群方案");
        return;
      }
      if (this.selectedRows.length > 20) {
        this.$message.warning("每次编辑不可超出20个人群");
        return;
      }
      this.sureLoading = true;
      confirmCrowd({
        platform: "JD",
        userId: this.loginUserInfo.platformAccountInfo.platformCompanyUserId,
        messageId: this.item.id,
        selectedCrowdNos: this.selectedRows.map((item) => item.crowdNo),
      })
        .then((res) => {
          this.sureLoading = false;
          if (res.code == 200) {
            this.$emit("comfirm", res.data);
            this.dialogVisible = false;
          }
        })
        .catch(() => {
          this.sureLoading = false;
        });
    },
    handleClose() {
      this.selectedRows = [];
      this.dialogVisible = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.text-wrap {
  white-space: pre-wrap;
}
.dialog-title {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
}
.dialog-sub {
  font-size: 12px;
  color: #999999;
  margin-left: 16px;
}
.select-group-content {
  width: 100%;
}
.select-group-header {
  padding: 0 0 12px;
}
.select-group-count {
  font-size: 14px;
  color: #333;
}
.select-group-table-wrapper {
  width: 100%;
}
</style>
